function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (e, o) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = o() : "function" == typeof define && define.amd ? define([], o) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.VueDragScroll = o() : e.VueDragScroll = o();
}(window, function () {
  return function (e) {
    var o = {};

    function t(n) {
      if (o[n]) return o[n].exports;
      var r = o[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(r.exports, r, r.exports, t), r.l = !0, r.exports;
    }

    return t.m = e, t.c = o, t.d = function (e, o, n) {
      t.o(e, o) || Object.defineProperty(e, o, {
        enumerable: !0,
        get: n
      });
    }, t.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, t.t = function (e, o) {
      if (1 & o && (e = t(e)), 8 & o) return e;
      if (4 & o && "object" == _typeof(e) && e && e.__esModule) return e;
      var n = Object.create(null);
      if (t.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & o && "string" != typeof e) for (var r in e) {
        t.d(n, r, function (o) {
          return e[o];
        }.bind(null, r));
      }
      return n;
    }, t.n = function (e) {
      var o = e && e.__esModule ? function () {
        return e["default"];
      } : function () {
        return e;
      };
      return t.d(o, "a", o), o;
    }, t.o = function (e, o) {
      return Object.prototype.hasOwnProperty.call(e, o);
    }, t.p = "/dist/", t(t.s = 0);
  }([function (e, o, t) {
    "use strict";

    t.r(o), t.d(o, "dragscroll", function () {
      return d;
    });

    var n = function n(e, o, t) {
      for (var n = 0, r = o.length; n < r; n++) {
        e.addEventListener(o[n], t, {
          passive: !1
        });
      }
    },
        r = function r(e, o, t) {
      for (var n = 0, r = o.length; n < r; n++) {
        e.removeEventListener(o[n], t, {
          passive: !1
        });
      }
    },
        i = function i(e, o, t) {
      var n;
      e.componentInstance ? e.componentInstance.$emit(o, t) : ("function" == typeof window.CustomEvent ? n = new window.CustomEvent(o, {
        detail: t
      }) : (n = document.createEvent("CustomEvent")).initCustomEvent(o, !0, !0, t), e.elm.dispatchEvent(n));
    };

    function l(e) {
      return (l = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
        return _typeof(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
      })(e);
    }

    var u = ["mousedown", "touchstart"],
        c = ["mousemove", "touchmove"],
        a = ["mouseup", "touchend"],
        s = function s(e, o, t) {
      var s = e,
          d = !0,
          f = window;
      "boolean" == typeof o.value ? d = o.value : "object" === l(o.value) ? ("string" == typeof o.value.target ? (s = e.querySelector(o.value.target)) || console.error("There is no element with the current target value.") : void 0 !== o.value.target && console.error("The parameter \"target\" should be either 'undefined' or 'string'."), "string" == typeof o.value.container ? (f = document.querySelector(o.value.container)) || console.error("There is no element with the current container value.") : void 0 !== o.value.container && console.error("The parameter \"container\" should be be either 'undefined' or 'string'."), "boolean" == typeof o.value.active ? d = o.value.active : void 0 !== o.value.active && console.error("The parameter \"active\" value should be either 'undefined', 'true' or 'false'.")) : void 0 !== o.value && console.error("The passed value should be either 'undefined', 'true' or 'false' or 'object'.");

      var m = function m(e, o) {
        f === window ? window.scrollBy(e, o) : (f.scrollLeft += e, f.scrollTop += o);
      },
          v = function v() {
        var e,
            r,
            l,
            d = !1;
        s.md = function (t) {
          var n = t instanceof window.MouseEvent,
              i = n ? t.pageX : t.touches[0].pageX,
              u = n ? t.pageY : t.touches[0].pageY,
              c = document.elementFromPoint(i - window.pageXOffset, u - window.pageYOffset),
              a = "nochilddrag" === o.arg,
              d = o.modifiers.noleft,
              f = o.modifiers.noright,
              m = o.modifiers.nomiddle,
              v = o.modifiers.noback,
              p = o.modifiers.noforward,
              w = "firstchilddrag" === o.arg,
              h = c === s,
              y = c === s.firstChild,
              g = a ? void 0 !== c.dataset.dragscroll : void 0 === c.dataset.noDragscroll;
          (h || g && (!w || y)) && (1 === t.which && d || 2 === t.which && m || 3 === t.which && f || 4 === t.which && v || 5 === t.which && p || (l = 1, e = n ? t.clientX : t.touches[0].clientX, r = n ? t.clientY : t.touches[0].clientY));
        }, s.mu = function (e) {
          l = 0, d && i(t, "dragscrollend"), d = !1;
        }, s.mm = function (n) {
          var u,
              c,
              a = n instanceof window.MouseEvent,
              f = {};

          if (l) {
            n.preventDefault(), d || i(t, "dragscrollstart"), d = !0;
            var v = s.scrollLeft + s.clientWidth >= s.scrollWidth || 0 === s.scrollLeft,
                p = s.scrollTop + s.clientHeight >= s.scrollHeight || 0 === s.scrollTop;
            u = -e + (e = a ? n.clientX : n.touches[0].clientX), c = -r + (r = a ? n.clientY : n.touches[0].clientY), o.modifiers.pass ? (s.scrollLeft -= o.modifiers.y ? -0 : u, s.scrollTop -= o.modifiers.x ? -0 : c, s === document.body && (s.scrollLeft -= o.modifiers.y ? -0 : u, s.scrollTop -= o.modifiers.x ? -0 : c), (v || o.modifiers.y) && m(-u, 0), (p || o.modifiers.x) && m(0, -c)) : (o.modifiers.x && (c = -0), o.modifiers.y && (u = -0), s.scrollLeft -= u, s.scrollTop -= c, s === document.body && (s.scrollLeft -= u, s.scrollTop -= c)), f.deltaX = -u, f.deltaY = -c, i(t, "dragscrollmove", f);
          }
        }, n(s, u, s.md), n(window, a, s.mu), n(window, c, s.mm);
      };

      d ? "complete" === document.readyState ? v() : window.addEventListener("load", v) : (r(s, u, s.md), r(window, a, s.mu), r(window, c, s.mm));
    },
        d = {
      inserted: function inserted(e, o, t) {
        s(e, o, t);
      },
      update: function update(e, o, t, n) {
        JSON.stringify(o.value) !== JSON.stringify(o.oldValue) && s(e, o, t);
      },
      unbind: function unbind(e, o, t) {
        var n = e;
        r(n, u, n.md), r(window, a, n.mu), r(window, c, n.mm);
      }
    },
        f = {
      install: function install(e, o) {
        var t = Number(e.version.split(".")[0]),
            n = Number(e.version.split(".")[1]);
        if (t < 2 && n < 1) throw new Error("v-dragscroll supports vue version 2.1 and above. You are using Vue@".concat(e.version, ". Please upgrade to the latest version of Vue."));
        e.directive("dragscroll", d);
      }
    };

    "undefined" != typeof window && window.Vue && (window.VueDragscroll = f, window.Vue.use(f));
    o["default"] = f;
  }]);
});